module.exports = __webpack_public_path__ + "static/media/logo-big.48470a09.svg";